import { Box } from '@material-ui/core'
import React, { useContext } from 'react'
import buildStyles from './styles'
import AppContext from '../../context'
import { OrganizationInfo } from '../../../api/types'
import { useNavigate } from 'react-router-dom'
import { setSelectedOrganization } from '../../context/actions'
import AppImage from '../../../components/AppImage'
import { transform } from '../../../utils/functions'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface OrganizationProps {
  organization: OrganizationInfo
  setShowedOrganization: (item: OrganizationInfo) => void
}

const Organization = ({
  organization,
  setShowedOrganization,
}: OrganizationProps) => {
  const { state } = useContext(AppContext)

  const { contextDispatch } = useContext(AppContext)
  const navigate = useNavigate()

  const TEXT_LENGTH = 100
  const description =
    organization && organization.description.length > 0
      ? organization.description.trim()
      : ''
  const needToTrim = description.length > TEXT_LENGTH
  const trimmedDescription = needToTrim
    ? description.substring(0, TEXT_LENGTH)
    : description

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <div
      className={styles.item}
      onClick={() => {
        setSelectedOrganization(contextDispatch, organization)
        navigate(`${organization.id}`)
      }}
    >
      <AppImage
        imageId={organization.imageId}
        maxHeight={120}
        alt="organization-logo"
        disabledPadding
      />
      <Box className={styles.name}>{transform(organization.name)}</Box>

      <div className={styles.description}>
        {needToTrim ? trimmedDescription + '...' : description}
      </div>

      <Box display="flex" alignSelf="flex-end" height="37px" marginTop="auto">
        {needToTrim && (
          <span
            className={styles.moreButton}
            onClick={(e) => {
              e.stopPropagation()
              setShowedOrganization(organization)
            }}
          >
            więcej
          </span>
        )}
      </Box>
    </div>
  )
}

export default Organization
